const formatTime = (
    timestamp
) => {

    if (!timestamp) {
        return "—";
    }


    return new Date(
        timestamp
    ).toLocaleTimeString();
};


export function EventFeed({
    events,
}) {

    return (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-5 shadow-xl shadow-black/10">

            <div className="mb-4 flex items-center justify-between">

                <div>
                    <p className="text-sm font-semibold text-slate-100">
                        Event Stream
                    </p>

                    <p className="text-xs text-slate-500">
                        Authoritative audit events surfaced in real time
                    </p>
                </div>

                <span className="text-xs text-slate-500">
                    {events.length}
                </span>

            </div>


            <div className="max-h-[420px] space-y-2 overflow-y-auto pr-1">

                {events.length === 0 ? (

                    <div className="rounded-xl border border-dashed border-slate-800 p-8 text-center text-sm text-slate-500">
                        Waiting for dashboard events…
                    </div>

                ) : (

                    events.map(
                        (event) => (

                            <div
                                key={event.id}
                                className="rounded-xl border border-slate-800 bg-slate-950/60 p-3"
                            >

                                <div className="flex items-center justify-between gap-3">

                                    <span className="truncate text-xs font-semibold text-slate-300">
                                        {event.type}
                                    </span>

                                    <span className="shrink-0 text-[11px] text-slate-600">
                                        {formatTime(
                                            event.timestamp
                                        )}
                                    </span>

                                </div>


                                <p className="mt-1 truncate text-xs text-slate-500">
                                    {event.payload?.symbol ??
                                        event.payload?.payload?.symbol ??
                                        "system"}
                                </p>

                            </div>
                        )
                    )
                )}

            </div>

        </div>
    );
}